<div class="custom-card p-4" *ngIf="partnerForm">
  <form class="custom-card-body" [formGroup]="partnerForm">
    <h1 class="mb-2">Community Organization Submission</h1>
    <p class="mb-4">
      Thank you for your interest in our Green and Healthy Schools Program and your interest in
      supporting teachers and students in Gwinnett County Schools. Please complete the information
      if your organization/business would like to be considered as a potential
      partner/presenter/volunteer for our GHS Programs.
    </p>
    <div class="row">
      <div class="col-md-6 col-12 mb-3">
        <label for="partnerName" class="form-label">Organization Name:</label>
        <input type="text" id="partnerName" formControlName="org" class="form-control"
               placeholder="Enter Organization Name" required
               [ngClass]="{'is-invalid': partnerForm.get('org')?.invalid && partnerForm.get('org')?.touched}">
      </div>
      <div class="col-md-6 col-12 mb-3">
        <label for="primeContact" class="form-label">Primary Contact Name:</label>
        <input type="text" id="primeContact" formControlName="primeContact" class="form-control"
               placeholder="Enter Primary Contact Name" required
               [ngClass]="{'is-invalid': partnerForm.get('primeContact')?.invalid && partnerForm.get('primeContact')?.touched}">
      </div>
      <div class="col-md-6 col-12 mb-3">
        <label for="email" class="form-label">Email:</label>
        <input type="email" id="email" formControlName="contactEmail" class="form-control" placeholder="Enter Email"
               required
               [ngClass]="{'is-invalid': partnerForm.get('contactEmail')?.invalid && partnerForm.get('contactEmail')?.touched}">
      </div>
      <div class="col-md-6 col-12 mb-3">
        <label for="phone" class="form-label">Phone:</label>
        <input type="tel" id="phone" formControlName="contactPhone" class="form-control" placeholder="1234567890"
               pattern="[0-9]{3}[0-9]{3}[0-9]{4}" maxlength="10" required
               [ngClass]="{'is-invalid': partnerForm.get('contactPhone')?.invalid && partnerForm.get('contactPhone')?.touched}" (keydown)="allowNumbersOnly($event)">
      </div>
      <div class="col-md-6 col-12 mb-3">
        <label for="scope" class="form-label">Scope (Area of Service):</label>
        <select id="scope" formControlName="areaOfService" class="form-select" required
                [ngClass]="{'is-invalid': partnerForm.get('areaOfService')?.invalid && partnerForm.get('areaOfService')?.touched}">
          <option value="gwinnett">Gwinnett</option>
          <option value="georgia">Georgia</option>
          <option value="national">National</option>
        </select>
      </div>
      <div class="col-md-6 col-12 mb-3">
        <label for="website" class="form-label">Website:</label>
        <input type="url" id="website" formControlName="website" class="form-control" placeholder="Enter Website URL"
               required
               [ngClass]="{'is-invalid': partnerForm.get('website')?.invalid && partnerForm.get('website')?.touched}">
      </div>
      <div class="col-md-6 col-12 mb-3">
        <label for="zipcodesServed" class="form-label">Zipcodes Served (Optional):</label>
        <input type="text" id="zipcodesServed" formControlName="zipcodesServed" class="form-control"
               placeholder="Enter Zipcodes Served">
      </div>
      <div class="col-md-6 col-12 mb-3">
        <label for="studentCapacity" class="form-label">Student Capacity:</label>
        <input type="number" id="studentCapacity" formControlName="studentCapacity" class="form-control"
               placeholder="Enter Student Capacity" appIntegerInput required
               [ngClass]="{'is-invalid': partnerForm.get('studentCapacity')?.invalid && partnerForm.get('studentCapacity')?.touched}">
      </div>

      <div class="col-12 mb-3">
        <label for="bio">Mission:</label>
        <textarea id="bio" class="form-control" formControlName="bio" rows="2" name="bio" required
                  [ngClass]="{'is-invalid': partnerForm.get('bio')?.invalid && partnerForm.get('bio')?.touched}"></textarea>
      </div>

      <div class="col-12 mb-3">
        <label for="notes">Partner Comments (Other Focus Areas or Services Offered that are not listed below):</label>
        <textarea id="notes" class="form-control mb-3" formControlName="notes" rows="2" name="notes"></textarea>
      </div>
    </div>

    <div class="mb-4">
      <div class="form-check mb-3">
        <input type="checkbox" id="titleOneDiscount" class="form-check-input" formControlName="titleOneDiscount"
               value="titleOneDiscount">
        <label for="titleOneDiscount" class="form-check-label">Title 1 Discount</label>
      </div>
    </div>

    <div id="servicesOffered" class="mb-4">
      <h2>Services Offered</h2>
      <div class="row">
        <div *ngFor="let control of servicesOfferedControls; let i = index" class="col-md-6">
          <label class="form-check-label mb-1">
            <input type="checkbox" class="form-check-input" [formControl]="control"/>
            {{ servicesOffered[i] }}
          </label>
        </div>
      </div>
    </div>

    <div id="focusAreas" class="mb-4">
      <h2>Project Focus Areas</h2>
      <div class="row">
        <div *ngFor="let control of focusAreasControls; let i = index" class="col-md-6">
          <label class="form-check-label mb-1">
            <input type="checkbox" class="form-check-input" [formControl]="control"/>
            {{ focusAreas[i] }}
          </label>
        </div>
      </div>
    </div>

    <div id="fundingSupport" class="mb-4">
      <h2>Funding Support</h2>
      <div class="row">
        <div *ngFor="let control of fundingSupportControls; let i = index" class="col-md-6">
          <label class="form-check-label mb-1">
            <input type="checkbox" class="form-check-input" [formControl]="control"/>
            {{ fundingSupport[i] }}
          </label>
        </div>
      </div>
    </div>

    <div class="mb-3">
      <label class="me-2">Are services Free or Fee based? <span class="text-danger">*</span></label>

      <input type="radio" id="free" formControlName="feeType" value="Free" class="me-1">
      <label for="free" class="me-2">Free</label>

      <input type="radio" id="fee" formControlName="feeType" value="Fee" class="me-1">
      <label for="fee" class="me-2">Fee</label>
    </div>

    <div *ngIf="partnerForm.get('feeType')?.value === 'Fee'">
      <div id="feeServices" class="mb-4">
        <h2>Fee Services</h2>
        <div class="row">
          <div *ngFor="let control of feeServicesControls; let i = index" class="col-md-6">
            <label class="form-check-label mb-1">
              <input type="checkbox" class="form-check-input" [formControl]="control"/>
              {{ feeServices[i] }}
            </label>
          </div>
        </div>
      </div>

      <div id="referredBy" class="mb-4">
        <h2>Referred By</h2>
        <input type="text" [ngClass]="partnerForm.get('referredBy')" class="form-control">
      </div>
    </div>

    <div class="mb-3">
      <label class="me-2">Status: <span class="text-danger">*</span></label>

      <input type="radio" id="active" formControlName="status" value="Active" class="me-1">
      <label for="active" class="me-2">Active</label>

      <input type="radio" id="inactive" formControlName="status" value="Inactive" class="me-1">
      <label for="inactive" class="me-2">Inactive</label>
    </div>

    <div class="d-flex gap-2 justify-content-center">
      <a routerLink="/find-partners" class="btn d-flex align-items-center btn-lg"
         style="background-color: red; color: white">
        CANCEL
        <span class="material-symbols-outlined ms-1">close</span>
      </a>
      <button id="submitBtn" type="button" class="btn btn-primary btn-lg" (click)="submitPartner($event)">
        SUBMIT
      </button>
    </div>

  </form>
</div>
